
import { ElMessage } from 'element-plus'
import { defineComponent, reactive, toRefs } from 'vue';
// import {uploadApi} from '../api/upload';
import axios from "axios";
export default defineComponent({
  name: "login",
  setup(){
      console.log(process.env);
      const rawData = reactive({
        imageUrl:'',
        headers: {"content-type": "multipart/form-data"}
      })
      function handleAvatarSuccess(res : any, file : any) {
        rawData.imageUrl = URL.createObjectURL(file.raw);
      }
      function beforeAvatarUpload(file : any) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          ElMessage.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          ElMessage.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }

      function uploadFile(item:any) {
        let file = item.file;
        const form = new FormData(); // FormData 对象
        form.append("files", file); // 文件对象  'upload'是后台接收的参数名
        //有qs这个格式化不行
        // uploadApi(form).then(res=>{
        //   console.log(res);
        // })
        //如果用了qs，这里就需要统一处理成
        axios.post('http://school.duzhitech.cn/api/Upload',form,{
          headers: {"content-type": "multipart/form-data"}
        }).then(res=>{
          if(res.data && res.data.state === 0){
            rawData.imageUrl = process.env.VUE_APP_BASE_URL as string + res.data.content
          }
        })
      }



      return {...toRefs(rawData),
      handleAvatarSuccess,beforeAvatarUpload,uploadFile
      }

  }
})
